<app-dialog
  #dialog
  [key]="'save-reversal-confirmation'"
  [action]="'save-reversal-confirmation'"
  [headerTheme]="'simple'"
  [title]="'Confirmar Salvamento de Reversão'"
  [maxWidth]="'760px'">
  <div class="save-reversal-confirmation" *ngIf="data">
    <p class="intro">
      Você está salvando uma cotação indicativa de reversão antecipada. Essa ação não liquida a
      operação atual: ela cria uma nova operação de reversão para análise e decisão.
    </p>

    <div class="summary-grid">
      <div class="summary-item">
        <span class="label">Data da liquidação</span>
        <span class="value">{{ data.settlementDate }}</span>
      </div>
      <div class="summary-item">
        <span class="label">Notional</span>
        <span class="value">{{ data.settlementNotional }}</span>
      </div>
      <div class="summary-item">
        <span class="label">Spot</span>
        <span class="value">{{ data.settlementSpot }}</span>
      </div>
      <div class="summary-item">
        <span class="label">Taxa de liquidação</span>
        <span class="value">{{ data.settlementRate }}</span>
      </div>
      <div class="summary-item full-row">
        <span class="label">Ajuste líquido estimado</span>
        <span class="value">{{ data.netAmount | vaultFormatCurrency: 2 }}</span>
      </div>
    </div>

    <div class="impact-box">
      <div class="impact-title">Ao confirmar, o sistema irá:</div>
      <ol>
        <li>Criar uma nova operação de reversão dentro da mesma demanda.</li>
        <li>Salvar essa nova operação com status <strong>Cotado</strong>.</li>
        <li>Registrar Spot, Taxa, Notional e Ajuste Líquido como histórico da cotação.</li>
        <li>Manter a operação original sem liquidação e sem alteração de status.</li>
        <li>Copiar os vínculos de parcelas e pagamentos COMEX da operação original.</li>
      </ol>
    </div>
  </div>

  <ng-template #footer>
    <div class="confirmation-footer">
      <app-button [theme]="'white'" [label]="'Cancelar'" (sendButtonClick)="close()"> </app-button>
      <app-button [label]="'Salvar Reversão'" (sendButtonClick)="handleConfirm()"> </app-button>
    </div>
  </ng-template>
</app-dialog>
